var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTeamTripToDubai = function SvgTeamTripToDubai(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.12 8.997c-.005-.322-.143-.612-.413-.87s-.627-.463-1.072-.615a4.489 4.489 0 0 0-1.476-.229h-3.375c-.24 0-.42-.026-.537-.079a1.493 1.493 0 0 1-.386-.308L6.245.796a.816.816 0 0 0-.633-.298h-1.02a.259.259 0 0 0-.237.132c-.053.082-.053.179 0 .29l2.892 6.354-4.237.484-1.512-2.742c-.11-.2-.298-.3-.562-.3h-.37a.345.345 0 0 0-.37.36v7.832c.002.112.034.202.098.273.07.064.162.096.273.096h.369c.264 0 .451-.1.562-.298l1.512-2.743 4.237.484-2.892 6.354c-.053.111-.053.208 0 .29a.26.26 0 0 0 .237.132h1.02c.246 0 .457-.1.633-.299l5.616-6.1c.14-.146.27-.245.386-.298.118-.059.296-.088.537-.088h3.375c.545 0 1.037-.076 1.476-.229.445-.152.803-.357 1.072-.615.27-.258.408-.548.413-.87Z",
    fill: "currentColor"
  })));
};

export default SvgTeamTripToDubai;